import PropTypes from 'prop-types';
import React from 'react';
import { formatPhoneNumber } from '@atc/string-fns';

/**
 *  The phone number component will accept an integer and run it through the formatPhoneNumber utility
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function PhoneNumber(_ref) {
  let {
    phoneNumber,
    extension,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("span", {
    "data-cmp": "phoneNumber",
    ...rest,
    children: formatPhoneNumber(phoneNumber, extension)
  });
}
export default PhoneNumber;